import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function MemberFormDialog({ account, open, onOpenChange, onSave, saving }) {
  const [form, setForm] = useState({});
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    if (open) {
      setForm({ name: account?.name || "", email: account?.email || "", username: account?.username || "", password: "", department: account?.department || "" });
      api.get("/departments").then(({ data }) => setDepartments(data.preset)).catch(() => setDepartments([]));
    }
  }, [account, open]);
  const submit = (event) => {
    event.preventDefault();
    if (!account && !form.department) return;
    const values = { name: form.name.trim() };
    if (form.department) values.department = form.department;
    if (!account) {
      Object.assign(values, { email: form.email.trim().toLowerCase(), password: form.password });
      if (form.username.trim()) values.username = form.username.trim().toLowerCase();
    }
    onSave(values);
  };
  return (
    <Dialog open={open} onOpenChange={(value) => { if (!saving) onOpenChange(value); }}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto rounded-none">
        <DialogHeader><DialogTitle>{account ? "Edit Member" : "Tambah Akun Departemen"}</DialogTitle>
          <DialogDescription>Admin membuat akun member dengan email wajib dan username opsional. Akun dengan departemen dapat melihat dan mengelola meeting dalam departemen tersebut.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block text-sm">Nama<Input required value={form.name || ""} onChange={(e) => setForm({ ...form, name: e.target.value })} /></label>
          {!account && <>
            <label className="block text-sm">Email<Input required type="email" autoComplete="email" value={form.email || ""} onChange={(e) => setForm({ ...form, email: e.target.value })} /></label>
            <label className="block text-sm">Password<Input required minLength={8} autoComplete="new-password" type="password" value={form.password || ""} onChange={(e) => setForm({ ...form, password: e.target.value })} /></label>
            <p className="text-xs text-muted-foreground">Password minimal 8 karakter.</p>
            <label className="block text-sm">Username (opsional)<Input minLength={3} maxLength={50} autoComplete="off" value={form.username || ""} onChange={(e) => setForm({ ...form, username: e.target.value })} /></label>
          </>}
          <label className="block text-sm">Departemen</label>
          <Select value={form.department || ""} onValueChange={(value) => setForm({ ...form, department: value })}>
            <SelectTrigger aria-label="Departemen member"><SelectValue placeholder={account ? "Tetap memakai akses pribadi" : "Pilih departemen"} /></SelectTrigger>
            <SelectContent>{departments.map((name) => <SelectItem key={name} value={name}>{name}</SelectItem>)}</SelectContent>
          </Select>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>Batal</Button>
            <Button type="submit" disabled={saving || (!account && !form.department)}>{saving ? "Menyimpan..." : "Simpan"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
